import { Component, OnInit } from '@angular/core';
import { Enums } from '../../shared/enums';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class AccessDeniedComponent implements OnInit {
    // #region [props]
    title: string = null;
    message: string = null;
    // #endregion

    constructor(public router: Router, private authService: AuthService) {
        if (authService.hasProfiles([Enums.Profiles.Administrator, Enums.Profiles.AdminAll])) {
            router.navigate(['/']);
        } else {
            this.title = Enums.Messages.AccessDenied;
            this.message = Enums.Messages.NoAccessToResource;
        }
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
